import { render, staticRenderFns } from "./NurseCallHistoryDetail.vue?vue&type=template&id=74807434&scoped=true"
import script from "./NurseCallHistoryDetail.vue?vue&type=script&lang=js"
export * from "./NurseCallHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./NurseCallHistoryDetail.vue?vue&type=style&index=0&id=74807434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74807434",
  null
  
)

export default component.exports